"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
function findPrimaryOrFirst() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _lodash.find)(items, {
    is_primary: true
  }) || (0, _lodash.first)(items) || {};
}
var _default = exports["default"] = findPrimaryOrFirst;